import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import { navigateCaseList } from "../actions/casesActions";
import {
  CASES_SUCCESS,
  CASES_REQUEST,
  CASES_FAILURE,
  CASE_ID_LIST_REQUEST,
  CASE_ID_LIST_SUCCESS,
  CASE_ID_LIST_FAILURE,
  NAVIGATE_CASE_LIST_SYNC,
  CASE_SIGN_OUT_SUCCESS,
  NAVIGATE_CASE_LIST_END_OF_LIST,
  DOCUMENTS_LIST_REQUEST,
  DOCUMENTS_LIST_FAILURE,
  DOCUMENTS_LIST_SUCCESS,
} from "../actions/constants";
import { wipeSlideDetail } from "../actions/slideDetailActions";

function* fetchCases(action: any): any {
  try {
    const result = yield call(
      ApiService.listCases,
      action.payload.serviceParams
    );
    yield put({
      type: CASES_SUCCESS,
      payload: {
        ...result,
        currentCaseSearch: action.payload.caseListPaginationParams,
        lastRequestTimestamp: action.payload.requestTimestamp,
      },
    });
  } catch (e) {
    yield put({
      type: CASES_FAILURE,
      error: true,
      payload: e,
    });
  }
}

// Action creator has set page=1 and paginationPerPage to INITIAL_FETCH_LIMIT.
function* fetchCaseListIds(action: any): any {
  try {
    const result = yield call(ApiService.listCases, action.payload);
    // yield delay(10000); // (Simulates a slow connection, using redux-saga/effects)
    yield put({
      type: CASE_ID_LIST_SUCCESS,
      payload: result.results.map((caseObj: { id: number }) => caseObj.id),
    });
  } catch (e) {
    yield put({
      type: CASE_ID_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* navigateCaseListNextCase(action: any): any {
  if (action.payload.navigate) {
    yield put(wipeSlideDetail()); // We don't want this stuff around esp. if next case has no slides
    yield action.payload.navigate(`/cases/${action.payload.id}`);
  }
}

function* navigateCaseListEndOfList(action: any): any {
  if (action.payload.navigate) {
    yield action.payload.navigate(action.payload.dashboardURL ?? "/");
  }
}

function* navigateAfterCaseSignoutNextCase(action: any): any {
  if (action.payload.navigate) {
    yield put(
      yield call(
        navigateCaseList,
        action.payload.navigate,
        true,
        action.payload.shortCircuitNavigation
      )
    );
  }
}

function* fetchCasesWithDocuments(action: any): any {
  try {
    const result = yield call(
      ApiService.listCasesWithDocuments,
      action.payload.serviceParams
    );
    yield put({
      type: DOCUMENTS_LIST_SUCCESS,
      payload: {
        ...result,
        category: action.payload.serviceParams.category,
        lastRequestTimestamp: action.payload.requestTimestamp,
      },
    });
  } catch (e) {
    yield put({
      type: DOCUMENTS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* casesSaga() {
  yield takeLatest(CASES_REQUEST, fetchCases);
  yield takeLatest(CASE_ID_LIST_REQUEST, fetchCaseListIds);
  yield takeLatest(NAVIGATE_CASE_LIST_SYNC, navigateCaseListNextCase);
  yield takeLatest(NAVIGATE_CASE_LIST_END_OF_LIST, navigateCaseListEndOfList);
  yield takeLatest(CASE_SIGN_OUT_SUCCESS, navigateAfterCaseSignoutNextCase);

  yield takeLatest(DOCUMENTS_LIST_REQUEST, fetchCasesWithDocuments);
}
